<template>
  <v-chart ref="chart" class="chart" :option="option" />
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  LineChart,
]);

export default {
  name: "LineChart",
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },
  props: {
    data: null
  },
  computed: {
    option() {
      let option =  {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        legend: {
          data: this.legends
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.categories
        },
        yAxis: {
          type: 'value'
        },
        series: this.series
      }
      if (this.$refs && this.$refs.chart) {
        this.$refs.chart.setOption(option, true);
        this.$nextTick(() => {
          this.$refs.chart.resize();
        })
      }
      return option;
    },
    categories() {
      let times = [];
      if (this.data) {
        let stores = Object.keys(this.data);
        if (stores && stores.length !== 0) {
          let storeSummary = this.data[stores[0]];
          for (let record of storeSummary) {
            times.push(record["time"] + '');
          }
        }

        return times;
      }
      return times;
    },
    legends() {
      return this.data ? Object.keys(this.data) : []
    },
    series() {
      let series = [];
      if (this.data) {
        for(let store in this.data) {
          let storeSummary = this.data[store];

          let record = {
            name: store,
            type: 'line',
            stack: 'Total',
            data: [],
            smooth: true
          };
          for (let data of storeSummary) {
            record.data.push(data["usage"]);
          }
          series.push(record);
        }
      }

      return series;
    }
  },
}
</script>

<style scoped>

</style>